<template>
<div>
    <form enctype="multipart/form-data" ref="moment_form" @submit.prevent="submit">
        <div class="title_block" :class="{'title_block_mod': props.data.is_quiz}">
            <div>
                <h5 class="modal-title font-active" id="exampleModalLabel">Get a Gemologist's Opinion</h5> 
            </div>
        </div>
        <p :class="{'p_mod': props.data.is_quiz}">Seek an opinion from our gemologist and {{ $t('jewelry') }} specialist <br> about this product. </p>
        <div class="row mt-4 moment_form" role="group">
            <div class="col-md-12 pb-3 column">
                <label class="mb-2">Your Name *</label>
                <input @focus="handleFocus('name')" name="name" required :class="{ 'is-invalid':errorMessages.name,'quiz-bg': props.data.is_quiz  }" type="text" v-model="formData.name"  />
                <span v-if="errorMessages.name" class="error-msg">{{ errorMessages.name.join(' ') }}</span>
            </div>

            <div class="col-md-12 pb-3 column">
                <label class="mb-2">Your Email Address *</label>
                <input @focus="handleFocus('email')" name="email" required :class="{ 'is-invalid': errorMessages.email,'quiz-bg': props.data.is_quiz  }" type="email" v-model="formData.email" />
                <span v-if="errorMessages.email" class="error-msg">{{ errorMessages.email.join(' ') }}</span>
            </div>

            <div class="col-md-12 pb-3 column">
                <div class="textarea_box">
                    <label for="">Your Message</label>
                    <textarea @focus="handleFocus('message')" size="lg" name="message" :rows="props.data.is_quiz ? 3 : 6" maxlength="512" :class="{'invalid': errorMessages.message,'quiz-bg': props.data.is_quiz }" placeholder="" v-model="formData.message"  />
                    <span v-if="errorMessages.message" class="error-msg">{{ errorMessages.message.join(" ") }}</span>
                    <p class="mb-0">{{formData.message.length}}/512 characters</p>
                </div>
            </div>
            
            <div class="col-md-12 pb-3 column" >
                <div class="filter_row">
                    <div class="checkbox_custom ms-0" @click="formData.newsletter = !formData.newsletter">
                        <span :class="{ 'checked' : formData.newsletter === true || formData.newsletter === 1,  'unchecked' : formData.newsletter === false || formData.newsletter === 0 }"></span>
                        <label class="mb-0">Send me updates on new styles and special offers</label>
                    </div>
                </div>
            </div>

            <div v-if="!showSuccess" class="col-md-12 pb-2">
                <CommonBasePrimary disabled v-if="showLoader">please wait...</CommonBasePrimary>
                <CommonBasePrimary v-else type="submit">submit</CommonBasePrimary>
            </div>

            <div v-if="showSuccess" class="col-md-12 pb-4">
                <div class="alert alert-primary mb-0" role="alert">Request successfully submitted </div>
            </div>
        </div>
    </form>
</div>
</template>

<script setup>

    const route = useRoute();
    const props = defineProps(['data'])
    const showSuccess = ref(false);
    const showLoader = ref(false);
    const errorMessages = ref({});
    const flagShowModal = ref(false);

    const emit = defineEmits(['hideModal'])

    const hideModal = () => {
        emit('hideModal')
    }

    const formData = reactive({
        // ---default----
        name: '',
        email: '',
        message: '',
        newsletter: true,

        // ----- product wise----
        module_type:'',
        item_type:null,
        setting_id: null,
        loose_id: null,
        loose_two_id: null
    })
  

    const emptyData = () => {
         // ---default----
        formData.name= '',
        formData.email= '',
        formData.message= '',
        formData.newsletter= true
        // ----- product wise----
        // formData.module_type='',
        formData.item_type=null,
        formData.setting_id= null,
        formData.loose_id= null,
        formData.loose_two_id= null,
        formData.loose_two_id= null
    }

    const checkZeroOne = (data)=>{
        for (const key of Object.keys(data)) {
            if(data[key] === true){
                data[key] = 1
            }
            if(data[key] === false){
                data[key] = 0
            }
        }
    }


    const submit = async ()=>{
        errorMessages.value = {}
        showLoader.value = true
        checkZeroOne(formData)

        try {
            const response = await $fetch(useCountryPath('/gemologist/store'), {
                method: 'POST',
                body: formData      
             })
            if (response) {
                showSuccess.value = true
                emptyData()
                setTimeout(() => {
                    flagShowModal.value = false
                    showSuccess.value = false
                    showLoader.value = false
                    hideModal()
                }, 2000);
            }
        } 
        catch (errors) {
            showLoader.value = false
            if (errors.data && errors.data.errors) {
            errorMessages.value = errors.data.errors;  
           } 
            if (errors.success === false) {
            toast('success', "Something went wrong, Please contact admin");
        }
        }
    }

    const handleFocus = (key) => {
        if(errorMessages.value.hasOwnProperty(key)){
            errorMessages.value[key] = '';
        }
    };

    onMounted(() => {
      if (route.name.includes('cyo-setting-detail')) {
          formData.setting_id = props.data.id;
          formData.module_type = 
          route.name.includes('cyo-setting-detail-ring') ? 'cyor' :
          route.name.includes('cyo-setting-detail-pendant') ? 'cyop' :
          route.name.includes('cyo-setting-detail-earring') ? 'cyoe' : '';
      }

      if (route.name.includes('cyo-diamond-detail')) {
        formData.loose_id = props.data.id;
        formData.module_type = 
          route.name.includes('cyo-diamond-detail-ring') ? 'cyor' :
          route.name.includes('cyo-diamond-detail-pendant') ? 'cyop' :
          route.name.includes('cyo-diamond-detail-earring') ? 'cyoe' : '';
      }

      if (route.name.includes('cyo-complete')) {
        formData.loose_id = props.data.diamond.id;
        formData.setting_id = props.data.setting.id;
        formData.module_type = route.name.includes('cyo-complete-ring') ? 'cyor' :
          route.name.includes('cyo-complete-pendant') ? 'cyop' :
          route.name.includes('cyo-complete-earring') ? 'cyoe' : '';
      }

      if (route.name.includes('loose-detail')) {
        formData.module_type = 'loose';
        formData.loose_id = props.data.id
      }

      if (route.name.includes('preset-detail')) {
        formData.module_type = 'preset';
        formData.setting_id = props.data.id;
      }

      if (route.name.includes('shop-detail')) {
        formData.module_type = 'shop';
        formData.item_type = props.data.sub_type;
        formData.setting_id = props.data.id;
      }

      if (['cyo-diamond-list-ring___us','cyo-diamond-list-ring___in', 'cyo-diamond-list-pendant___us','cyo-diamond-list-pendant___in',  'loose-listing___us', 'loose-listing___in'].includes(route.name)) {
        formData.module_type = 'diamond_quiz';
        formData.payload = props.data.payload;
        // formData.setting_id = props.data.id;
      }
      
    });
</script>

<style scoped>
    .quiz-bg {
        background: transparent;
    }
    input{
        border-radius: 4px;
        font-size: 16px;
    }
    textarea {
        border-radius: 4px;
        font-size: 16px;
    }
    .modal-content{
        padding: 2%;
        border-radius: 8px;
    }
    .checkbox_custom {
        font-size: 14px;
        font-weight: 600;
    }
    span{
        color: #363030;
        font-size: 14px;
        font-weight: 600;
    }
    .gemo_box{
        cursor: pointer;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        width: 100%;
        padding: 13px 15px;
        height: 50px;
    }
    .gemo_box img {
        border-radius: 50%;
    }
    .title_block{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title_block_mod {
        justify-content: center;
    }

    .title_block span {
        cursor: pointer;
    }
    .title_block h5 {
        font-size: 20px;
    }
    p{
        font-size: 16px;
        margin-bottom: 0;
        padding-top: 9px;
        color: #606060;
    }

    .p_mod {
        text-align: center;
    }

    .p_mod br {
        display: none;
    }

    .largesvg {
        transform: scale(1.3);
    }

    @media(max-width: 767px){
        p br{
            display: none;
        }
    }
</style>